import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/castroville")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Castroville, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Castroville & Medina County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Castroville, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Castroville and Medina County.",
      keywords: "awnings Castroville, awning company Castroville, custom awnings Castroville, sail shades Castroville, patio covers Castroville, pergola covers Castroville, metal awnings Castroville, canvas awnings Castroville, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Castroville", "Medina County"),
  }),
  component: () => <CityHomePage city="Castroville" region="Medina County" />,
});
